(function () {
  if (window.lopMegaBadges) return;
  window.lopMegaBadges = true;

  function norm(href) {
    if (!href) return '';
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (err) {
      return href;
    }
  }

  function activeUrls(scope) {
    var set = Object.create(null);
    var pane = null;
    var mega = scope.closest('[data-lop-mega]');
    if (mega) {
      var tab = mega.querySelector('[data-lop-tab].is-active');
      if (tab) {
        pane = mega.querySelector('.lop-mega__logos:not(.lop-mega__logos--badge)[data-lop-pane="' + tab.dataset.lopTab + '"]');
      }
    }
    if (!pane) {
      var root = scope.closest('.lop-drawer__body') || scope;
      var selected = root.querySelector('[data-lop-tabs] [role="tab"][aria-selected="true"]');
      if (selected) pane = document.getElementById(selected.getAttribute('aria-controls'));
    }
    if (!pane) return set;
    pane.querySelectorAll('a[href]').forEach(function (a) {
      set[norm(a.getAttribute('href'))] = true;
    });
    return set;
  }

  function syncScope(scope) {
    var urls = activeUrls(scope);
    var anyOn = false;
    scope.querySelectorAll('[data-lop-badge]').forEach(function (btn) {
      var list = document.getElementById(btn.getAttribute('aria-controls'));
      var n = 0;
      if (list) {
        list.querySelectorAll(':scope > li').forEach(function (li) {
          var a = li.querySelector('a[href]');
          var ok = !!(a && urls[norm(a.getAttribute('href'))]);
          li.hidden = !ok;
          if (ok) n += 1;
        });
      }
      var showChip = n > 0;
      btn.hidden = !showChip;
      var pressed = btn.getAttribute('aria-pressed') === 'true' && showChip;
      if (list) list.hidden = !pressed;
      if (pressed) anyOn = true;
    });
    var bar = scope.querySelector('.lop-mega__chips, .lop-drawer__badges');
    if (bar) bar.hidden = !bar.querySelector('[data-lop-badge]:not([hidden])');
    scope.toggleAttribute('data-lop-badge-active', anyOn);
  }

  function syncAll() {
    document.querySelectorAll('[data-lop-badges-scope]').forEach(syncScope);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lop-badge]');
    if (btn && !btn.hidden) {
      var scope = btn.closest('[data-lop-badges-scope]');
      if (!scope) return;
      var clear = e.target.closest('.lop-mega__chip-clear');
      var on = clear ? false : btn.getAttribute('aria-pressed') !== 'true';
      scope.querySelectorAll('[data-lop-badge]').forEach(function (b) {
        b.setAttribute('aria-pressed', on && b === btn ? 'true' : 'false');
      });
      syncScope(scope);
      return;
    }
    if (e.target.closest('[data-lop-tab], [data-lop-tabs] [role="tab"]')) syncAll();
  });

  document.addEventListener('mouseover', function (e) {
    if (e.target.closest('[data-lop-tab]')) syncAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.target.closest('[data-lop-tabs] [role="tab"]')) syncAll();
  });

  syncAll();
})();
